import * as React from "react";
const SvgFiRrOpacity = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-opacity_svg__a)">
      <path d="M2.886 6.836a1 1 0 0 0 .829-.436 10 10 0 0 1 2.809-2.77 1 1 0 1 0-1.1-1.672A12 12 0 0 0 2.06 5.275a1 1 0 0 0 .826 1.56M2 12c0-.66.064-1.32.193-1.969A1 1 0 1 0 .232 9.64c-.31 1.561-.31 3.168 0 4.728a1 1 0 0 0 1.18.781 1 1 0 0 0 .784-1.177A10 10 0 0 1 2 12.001M6.528 20.372a10 10 0 0 1-2.81-2.766 1 1 0 0 0-1.656 1.123 12 12 0 0 0 3.37 3.315 1 1 0 1 0 1.1-1.672zM12 0q-1.095.002-2.171.2a1 1 0 1 0 .36 1.968q.898-.166 1.81-.168v20q-.913 0-1.81-.164a1 1 0 0 0-.36 1.968A12.01 12.01 0 0 0 23.999 12 12.014 12.014 0 0 0 12 0" />
    </g>
    <defs>
      <clipPath id="fi-rr-opacity_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOpacity;
